export default "__VITE_ASSET__C9NCmv_8__"